// Helper functions for axios interceptor error handling

import { JWT_EXPIRED, JWT_MALFORMED, axiosApi } from "../constants/Constant";

export const isAbortError = (error: any): boolean => {
    return (
        error.name === 'AbortError' || 
        error.name === 'CanceledError' ||
        error.code === 'ERR_CANCELED' ||
        error.message?.includes('aborted') ||
        error.message?.includes('operation was aborted') ||
        error.message?.includes('Rejected from abort signal')
    );
};

export const shouldRetryRequest = (error: any, originalRequest: any): boolean => {
    return error.response?.status === 401 && !originalRequest?._retry;
};

export const extractBlobErrorMessage = async (error: any): Promise<string> => {
    const defaultMessage = "blob Error";
    
    if (!(error.response.data instanceof Blob) || error.response.data.type !== "application/json") {
        return error.response.data.message || defaultMessage;
    }
    
    try {
        const text = await error.response.data.text();
        const json = JSON.parse(text);
        return json.message;
    } catch (err) {
        console.warn("Failed to parse blob error response:", err);
        return defaultMessage;
    }
};

export const isTokenExpired = (errorMessage: string): boolean => {
    return errorMessage === JWT_EXPIRED;
};

export const isAuthError = (errorMessage: string): boolean => {
    return errorMessage === JWT_MALFORMED || errorMessage === axiosApi.TOKEN_DENIED;
};

export const clearAuthAndRedirect = (): void => {
    localStorage.clear();
    globalThis.location.href = '/';
};
